import React from 'react';
import { Route } from 'react-router-dom';
import { INVOICES, INVOICE_DETAILS } from './paths';
import Invoices from 'modules/Invoices/Invoices';
import InvoiceDetails from 'modules/Invoices/InvoiceDetails/InvoiceDetails';
export default function InvoicesRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: INVOICES
  }, /*#__PURE__*/React.createElement(Invoices, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: INVOICE_DETAILS(':invoiceNumber')
  }, /*#__PURE__*/React.createElement(InvoiceDetails, null)));
}